var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button-full',{attrs:{"disabled":_vm.isProductDisabled,"data-testid":"addToCart"},nativeOn:{"click":function($event){return _vm.addToCart(_vm.product)}}},[_vm._v("\n  "+_vm._s(_vm.$t('Add to cart'))+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }